import { Injectable } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';

@Injectable({
	providedIn: 'root',
})
export class MsDialogConfirmationService {
	constructor(private _confirmationService: ConfirmationService) {}

	confirm(confirmation: Confirmation): void {
		if (confirmation.header === undefined) {
			confirmation.header = '';
		}
		if (confirmation.message === undefined) {
			confirmation.message = '';
		}
		if (confirmation.icon === undefined) {
			confirmation.icon = '';
		}
		if ((confirmation as any).rejectButtonStyleClass === undefined) {
			(confirmation as any).rejectButtonStyleClass = 'p-button-outlined';
		}
		if (confirmation.accept === undefined) {
			confirmation.accept = () => {};
		}
		if (confirmation.reject === undefined) {
			confirmation.reject = () => {};
		}

		// PrimeNG v19 mapping: acceptLabel/rejectLabel -> acceptButtonProps/rejectButtonProps
		const anyConf: any = confirmation as any;
		if (anyConf.acceptLabel) {
			anyConf.acceptButtonProps = {
				...(anyConf.acceptButtonProps || {}),
				label: anyConf.acceptLabel,
			};
		}
		if (anyConf.rejectLabel) {
			anyConf.rejectButtonProps = {
				...(anyConf.rejectButtonProps || {}),
				label: anyConf.rejectLabel,
			};
		}
		if (anyConf.acceptButtonStyleClass) {
			anyConf.acceptButtonProps = {
				...(anyConf.acceptButtonProps || {}),
				styleClass: anyConf.acceptButtonStyleClass,
			};
		}
		if (anyConf.rejectButtonStyleClass) {
			anyConf.rejectButtonProps = {
				...(anyConf.rejectButtonProps || {}),
				styleClass: anyConf.rejectButtonStyleClass,
			};
		}

		this._confirmationService.confirm(confirmation);
	}
}
